import * as RadixSwitch from '@radix-ui/react-switch';

import styles from './Switch.module.css';

/**
 * Ein Schalter — nur das Bedienelement, ohne Zeile darum.
 *
 * Radix liefert das Verhalten: `role="switch"`, Tastaturbedienung, `data-state` zum Anmalen.
 * Die Umgebung (Zeile, Beschriftung, Abstände) stellt jeder Ort selbst — ein Schalter in einer
 * Einstellungsliste sieht anders aus als einer in einer Kopfzeile, das Verhalten ist dasselbe.
 *
 * ⚠️ **Die Beschriftung gehört dem Aufrufer**, aber die Verknüpfung nicht: wer ein `<label
 * htmlFor>` setzt, gibt hier dieselbe `id` mit. Ohne Beschriftung daneben gehört `ariaLabel`
 * gesetzt, sonst ist der Schalter für VoiceOver namenlos.
 */
export function Switch({
  id,
  on,
  onChange,
  disabled,
  ariaLabel,
  className,
}: {
  id?: string;
  on: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
}) {
  return (
    <RadixSwitch.Root
      id={id}
      checked={on}
      onCheckedChange={onChange}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`tap ${styles.switch} ${className ?? ''}`}
    >
      <RadixSwitch.Thumb className={styles.thumb} />
    </RadixSwitch.Root>
  );
}
